import { render, staticRenderFns } from "./_boxlogin.vue?vue&type=template&id=46e68074&scoped=true"
import script from "./_boxlogin.vue?vue&type=script&lang=js"
export * from "./_boxlogin.vue?vue&type=script&lang=js"
import style0 from "./_boxlogin.vue?vue&type=style&index=0&id=46e68074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e68074",
  null
  
)

export default component.exports